import { ShiftDetail } from 'api/services/shift/schema/shift-detail.schema';
import { ReactNode } from 'react';
import { ModalPanelTabType } from 'redesign';

export enum ShiftDetailTab {
  APPLICATIONS,
  TEAM,
  CANCELS,
  ADD,
  POOL,
  PARTNERS,
  ADD_PARTNER,
  PREFERRED_WORKERS,
  LOGS,
}

export type ShiftDetailProps = {
  close: () => void;
  shiftQueryResult: ShiftDetail;
  options: ModalPanelTabType[];
  shiftDetailHeadActions: ReactNode;
  isArchiving: boolean;
};

export type ShiftDetailTabData = {
  id: ShiftDetailTab;
  tabLabel: React.ReactNode;
  element: React.ReactNode;
};
